import { cloneElement, useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import * as API from '@/services/api.js'
import { handleError } from '@/services/errorHandler.js'
import { MainLoader } from '@/components/loader/MainLoader.jsx'
import { toast } from 'sonner'
import { AUTH_BASE_PATH } from '@/consts/index.js'

export function CreativeShareDataProvider({ children }) {
    const { creativeId } = useParams()
    const [searchParams] = useSearchParams()
    const uniqueKey = searchParams.get('uniqueKey') || ''
    const [creative, setCreative] = useState(null)
    const [error, setError] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        if (!creativeId) {
            navigate('/')
            return
        }
        let cancelled = false
        const fetchData = async () => {
            try {
                const { data } = await API.getCreativeSharePublic(creativeId, uniqueKey)
                if (cancelled) return
                if (!data) {
                    toast.error('Creative not found')
                    navigate('/')
                    return
                }
                setCreative(data)
            } catch (e) {
                if (cancelled) return
                setError(e?.message || 'Failed to load')
                handleError(e)
                toast.error('Could not load shared creative')
                navigate(AUTH_BASE_PATH)
            }
        }
        fetchData()
        return () => { cancelled = true }
    }, [creativeId, uniqueKey, navigate])

    if (error) return null
    if (!creative) return <MainLoader className="absolute inset-0 w-full h-full z-10 bg-background" />

    return cloneElement(children, { creative })
}
